import { View, Text } from 'react-native'
import styled from 'styled-components/native'

export const SC = {
  Container: styled(View)`
    width: 100%;
    align-self: center;
  `,
  CenterSelf: styled(View)`
    align-self: center;
  `,
  PanelContainer: styled(View)`
    border: 1px solid #d3dce6;
    border-radius: 8px;
    background-color: #fafafa;
    padding: 16px;
    :hover {
      background-color: red;
    }
  `,
  Row: styled(View)`
    flex-direction: row;
    justify-content: space-beetween;
    //align-items: flex-end;
    flex-wrap: wrap;
  `,
  Input: styled(View).attrs<{ flex?: number }>((p) => ({
    style: {
      flex: p.flex
    }
  }))``,
  SessionText: styled(Text)`
    font-weight: bold;
  `,
  TitleText: styled(Text)<{ fontSize?: number }>`
    font-weight: bold;
    color: #70777e;
    font-size: ${(p) => (p.fontSize ?? 15) + 'px'};
  `,
  NormalText: styled(Text)``,
  Divider: styled(View)<{ height?: number; width?: number; spacer?: boolean }>`
    width: ${(p) => (p.width ?? 10) + 'px'};
    height: ${(p) => (p.height ?? 10) + 'px'};
  `,
  Colum: styled(View)<{ flex?: number }>`
    flex: ${(p) => p.flex || 1};
  `,
  ErrorText: styled(Text)`
    color: red;
  `,
  InfoText: styled(Text)<{ color?: string }>`
    color: ${(props) => props.color || 'red'};
    padding: 20px 0px 20px 0px;
  `,
  InputContainer: styled(View)<{ flex?: number; maxWidth?: number }>`
    flex: ${(p) => p.flex || 1};
    max-width: ${(p) => (p.maxWidth || 250) + 'px'};
  `,
  Padding: styled(View)<{
    top?: number
    bottom?: number
    left?: number
    right?: number
    vertical?: number
    horizontal?: number
  }>`
    padding-top: ${(p) => p.top || p.vertical || 0};
    padding-bottom: ${(p) => p.top || p.vertical || 0};
    padding-right: ${(p) => p.top || p.horizontal || 0};
    padding-left: ${(p) => p.top || p.horizontal || 0};
  `,
  ImageThumb: styled.Image`
    width: 50px;
    height: 50px;
  `,
  ItalicText: styled.Text`
    font-style: italic;
    color: grey;
    font-size: small;
  `,
  BottomDashContainer: styled(View)`
    border-bottom-width: 1px;
    border-style: dashed;
  `
}
